import React from 'react'

const Footer = () => {
  return (
    <div className="copyright">
      <p className="p-text">@2022 IGNACIO</p>
      <p className="p-text">All rights reserved</p>
      <p className="p-text">Thanks to: <a href='https://github.com/adrianhajdin/project_professional_portfolio'>adrianhajdin</a></p>
    </div>
  )
}

export default Footer